import { useParams } from 'react-router-dom';

import { useCreditCardDetails } from '@/components/modules/_shared/hooks/useCreditCard';
import { CreditCardHeaderDetails } from '@/components/modules/CreditCard/Detail/Overview/components/CreditCardHeaderDetails';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { PendingDataType } from '@/config/types';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const CreditCardOverview = () => {
  const { creditCardId } = useParams();

  if (!creditCardId) {
    return null;
  }

  return <CreditCardOverviewWithParams creditCardId={creditCardId} />;
};

interface CreditCardOverviewWithParamsProps {
  creditCardId: string;
}

const CreditCardOverviewWithParams = ({ creditCardId }: CreditCardOverviewWithParamsProps) => {
  const { creditCardDetails, workflow } = useCreditCardDetails({ creditCardId });

  if (!creditCardDetails || !workflow) {
    return <PendingDataWarning type={PendingDataType.DEFAULT} />;
  }

  return <CreditCardHeaderDetails creditCard={creditCardDetails} workflow={workflow} />;
};

export const CreditCardOverviewModule = withPermissionsModule(CreditCardOverview);
